/* tslint:disable */
/* eslint-disable */

/**
 * 0 = AwaitingCount
 * 
 * 1 = Good
 * 
 * 2 = PartialDamage
 * 
 * 3 = Damaged
 * 
 * 4 = IncorrectItems
 */
export enum GoodsInCondition {
  AwaitingCount = 0,
  Good = 1,
  PartialDamage = 2,
  Damaged = 3,
  IncorrectItems = 4
}
